var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-table',{attrs:{"input-mode":"","data":_vm.emailList}},[_c('b-table-column',{attrs:{"field":"Email","label":_vm.RecEmailCatalog.Email.Label},scopedSlots:_vm._u([{key:"default",fn:function({ column, row }){return [_c('kst-output',{attrs:{"error-off":"","field-only":"","field":column.field,"data":row,"catalog":_vm.RecEmailCatalog}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }